import type { PlaybackEndpoints } from '@amzn/amp-playback'
import { getApiHost, getDmlsHost } from '@/service/useLiveHost'

export const webPlaybackEndpoints: PlaybackEndpoints = {
    apiHost: getApiHost,
    dmlsHost: getDmlsHost,
    pageOrigin: () => location.origin,
    pageUrl: () => location.href,
}
